import React, {useState, useEffect, useRef} from 'react'
import {Link} from 'react-router-dom';
import NumberFormat from './../../components/NumberFormat';
import Card from 'components/Card';
import {GridItem} from 'components/Grid';
import IconSave from '../../assets/img/icons/icon-save@3x.png';
import IconLove from '../../assets/img/icons/icon-love@3x.png';
import Utils from 'utils/Utils';

// import IconLove from '../../assets/img/no-photo.png';
import './AdventureCard.scss';
// import Utils from 'utils/Utils';

const AdventureCard = ({adventure, onFavorite, isLogged, minimal, match}) => {
  const [loadImage, setLoadImage] = useState(false)
  const [windowBottom, setWindowBottom] = useState(window.pageYOffset + window.innerHeight)
  const ref = useRef(null)

  const size = Utils.getWindowBreakpoint();

  window.addEventListener("scroll", () => {
    setWindowBottom(window.pageYOffset + window.innerHeight)
  })

  useEffect(() => {
    if (ref.current.getBoundingClientRect().y - windowBottom < 0 && !loadImage) {
      setLoadImage(true)
    }
  }, [windowBottom])

  return (
    <GridItem lg={3} md={4} sm={6} xs={12}>
      <Card>
        <div className="relative adventure-card" ref={ref}>
          <Link to={minimal ? `/site/${adventure.company_url}/${adventure.urlName}` : adventure.urn}>
            <div className="adventure-box">
              <div className="div-img overlay"
                   style={loadImage ? {backgroundImage: `url(${adventure.image[`url_${size}`]})`} : {backgroundColor: '#fff'}}
              >
                <span className="adventure-category">
                  {minimal ? 
                    adventure.categoryName
                  : 
                    <Link to={`/${adventure.region_url}/${adventure.categoryUrl}`}>
                      {adventure.categoryName}
                    </Link>
                  }
                </span>
                {(parseFloat(adventure.price) > 0) &&
                <div className="adventure-price">
                  {(!!adventure.priceWithDiscount) ?
                    <div>
                      <div className="adventure-old-price">
                        <NumberFormat value={adventure.price}/>
                      </div>
                      <span className="currency">R$</span><NumberFormat value={adventure.priceWithDiscount}/>
                    </div>
                    :
                    <div>
                      <span className="currency">R$</span><NumberFormat value={adventure.price}/>
                    </div>
                  }
                </div>
                }
              </div>
            </div>
          </Link>
          {!minimal && <img className="love-icon"
               src={(adventure.favorite === true && isLogged ? IconSave : IconLove)}
              onClick={() => onFavorite(adventure.pkAdventure)} alt="Curtir"/> }
          <div className="location">
            <small>
              {
                minimal ? 
                `${adventure.city}/${adventure.state}`
                :
                <Link to={`/${adventure.region_url}`}>
                  {adventure.city}/{adventure.state}
                </Link>
              }
            </small>
          </div>
          <div className="description">
            <h3><Link to={minimal ? `/site/${adventure.company_url}/${adventure.urlName}` : adventure.urn}>
              {adventure.title}
            </Link></h3>
          </div>
          <div className="enterprise">
            <strong>{adventure.company}</strong>
          </div>
          <ul className="tags">
            {adventure.tags.map(
              tag => (
                <li className="tag" key={tag.pk_tag}>
                  {tag.url_name && !minimal ?
                    <Link to={`/tags/${tag.url_name}`}>
                      {tag.name}
                    </Link>
                    : tag.name}
                </li>
              )
            )}
          </ul>
        </div>
      </Card>
    </GridItem>
  )
}

export default AdventureCard
